





























































































































import Vue from "vue";
import { MODULE_COLORS } from "@/utility/Constants";
import moment from "moment";

// Vuex
import { RootState } from "@/store";
import { mapState, mapActions, mapGetters } from "vuex";
import * as a from "@/store/modules/UpdatePackagesModule/actions";

// Vue Components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import UpdateTypeFilter from "@/components/TableHeaderFilters/UpdateTypeFilter.vue";
import AppPage from "@/components/AppPage.vue";
import DetailsModal from "./DetailsModal.vue";
import EditPackageModal from "./EditPackageModal.vue";
import DeletePackageModal from "./DeletePackageModal.vue";
import AddPackageModal from "./AddPackageModal.vue";
import PostAddPackageModal from "./PostAddPackageModal.vue";

// Model
import { GetI18nStringFromUpdateType, UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { UpdatePackageInstallationsCount } from "@/model/data/updates/UpdatePackageInstallationsCount";
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { UpdatePackage } from "@/model/data/updates/UpdatePackage";
import { GetOrganizationsCommand, GetOrganizationsResData } from "@/model/communication/organizations/GetOrganizationsCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { Organization } from "@/model/data/organizations/Organization";

export default Vue.extend({
    components: {
        AppPage,
        DetailsModal,
        EditPackageModal,
        DeletePackageModal,
        AddPackageModal,
        TableFiltersRow,
        PostAddPackageModal,
    },

    data() {
        return {
            moment,
            UpdateTypeEnum,
            VersionObfuscator,
            MODULE_COLORS,
            filters: [
                {
                    headerValue: "updateType",
                    filterKey: "updateTypeFilter",
                    component: UpdateTypeFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "targetModels",
                    filterKey: "targetModelsFilter",
                    component: MachineModelFilter,
                    currentSelections: [],
                },
            ],
            showDetailsModal: false,
            showEditPackageModal: false,
            showDeletePackageModal: false,
            showAddPackageModal: false,
            selectedPackage: {},
            treeLoaded: false,
            updateTypeFilter: [],
            targetModelsFilter: [],
            search: "",
            options: {},
            addedPackages: [],
            showPostAddPackageModal: false,
            visibleOrganizations: [],
            organizationsLoading: false,
        };
    },

    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        ...mapState({
            isUpdatePackagesListFetching: (state: RootState) => state.updatePackages.isUpdatePackagesListFetching,
            updatePackagesList: (state: RootState): UpdatePackageInstallationsCount[] => state.updatePackages.updatePackagesList,
            authUser: (state: RootState) => state.authMod.currentUser,
        }),

        uploadUpdatePackagesPrivilege() {
            return this.authUser.profile.privileges.and(ClientPrivileges.UploadUpdatePackages) == ClientPrivileges.UploadUpdatePackages;
        },
        updatePackageListFiltered() {
            let filteredUpdatePackages = this.updatePackagesList;
            if (this.updateTypeFilter && this.updateTypeFilter.length) {
                filteredUpdatePackages = filteredUpdatePackages.filter((u: UpdatePackageInstallationsCount) => this.updateTypeFilter.includes(u.updateType));
            }
            if (this.targetModelsFilter && this.targetModelsFilter.length) {
                filteredUpdatePackages = filteredUpdatePackages.filter((u: UpdatePackageInstallationsCount) =>
                    this.targetModelsFilter.some((t: string) => u.targetModels.includes(t))
                );
            }
            return filteredUpdatePackages;
        },
        headers() {
            let headers = [
                { text: "", value: "packageIcon", width: "5%" },
                { text: this.$t("common.file_name"), value: "fileName" },
                {
                    text: this.$t("update_packages.update_type"),
                    value: "updateType",
                    align: "center",
                    width: "auto",
                },
                {
                    text: this.$t("update_packages.version"),
                    value: "version",
                    align: "center",
                    width: "auto",
                },
                {
                    text: this.$t("update_packages.target_installations"),
                    value: "targetInstallationsCount",
                    align: "center",
                    sortable: false,
                    width: "auto",
                },
                {
                    text: this.$t("update_packages.target_models"),
                    value: "targetModels",
                    sortable: false,
                    align: "center",
                    width: "auto",
                },
            ];
            if (this.authUserHasPrivilege(ClientPrivileges.OrganizationsManagement) && this.visibleOrganizations && this.visibleOrganizations.length > 1) {
                headers.push({
                    text: this.$t("update_packages.target_org"),
                    value: "targetOrganizations",
                    sortable: false,
                    align: "center",
                    width: "auto",
                });
            }
            headers.push(
                {
                    text: this.$t("update_packages.uploadedAt"),
                    value: "uploadTimestamp",
                    sortable: true,
                    align: "center",
                    width: "auto",
                },
                {
                    text: this.$t("common.actions"),
                    value: "actions",
                    align: "center",
                    sortable: false,
                    width: "130px",
                }
            );
            return headers;
        },
    },

    methods: {
        ...mapActions([a.ON_UPDATE_PACKAGE_PAGE_LOAD, a.FETCH_UPDATE_PACKAGES_LIST]),
        GetI18nStringFromUpdateType,

        enableDetailsModal(item) {
            this.selectedPackage = item;
            this.showDetailsModal = true;
        },

        enableDeletePackageModal(item) {
            this.selectedPackage = item;
            this.showDeletePackageModal = true;
        },

        enableEditPackageModal(item) {
            this.selectedPackage = item;
            this.showEditPackageModal = true;
        },

        closeEditModal() {
            this.showEditPackageModal = false;
            this[a.FETCH_UPDATE_PACKAGES_LIST]();
        },
        filterChanged(filters) {
            this.backToTheFirst();
            let updateFilter = filters.filter((f) => f.filterKey == "updateTypeFilter");
            if (updateFilter.length == 1) {
                this.updateTypeFilter = updateFilter[0].currentSelections;
            }
            let targetModelFilters = filters.filter((f) => f.filterKey == "targetModelsFilter");
            if (targetModelFilters.length == 1) {
                this.targetModelsFilter = targetModelFilters[0].currentSelections;
            }
        },
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
        onAddPackage(addedPackages: Map<number, string>) {
            this.showAddPackageModal = false;
            if (addedPackages && addedPackages.size) {
                addedPackages.forEach((filename: string, id: number) => {
                    let up = new UpdatePackage();
                    up.id = id;
                    up.fileName = filename;
                    this.addedPackages.push(up);
                });
                this.showPostAddPackageModal = true;
            }
        },
        onClosePostAddPackage() {
            this.addedPackages = [];
            this.showPostAddPackageModal = false;
        },
    },

    async mounted() {
        this.treeLoaded = false;
        this.organizationsLoading = true;
        if (this.authUserHasPrivilege(ClientPrivileges.OrganizationsManagement)) {
            let res: GetOrganizationsResData = await new GetOrganizationsCommand().execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.visibleOrganizations = res.organizations;
            }
        } else if (this.authUser && this.authUser.profile && this.authUser.profile.organizationId) {
            let org = new Organization();
            org.id = this.authUser.profile.organizationId;
            this.visibleOrganizations = [org];
        }
        this[a.ON_UPDATE_PACKAGE_PAGE_LOAD]();
        this[a.FETCH_UPDATE_PACKAGES_LIST]();
        this.treeLoaded = true;
        this.organizationsLoading = false;
    },
});
